import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import API from "../../../../app/api";
import { getReason } from "../../../../services/orderService";

export const useReturnOrder = (orderNo, items = [], navigate) => {
    const [reason, setReason] = useState("");
    const [reasonList, setReasonList] = useState([]);
    const [comments, setComments] = useState("");
    const [loading, setLoading] = useState(false);

    /**
     * Fetch return reasons
     */
    const fetchReasons = useCallback(async () => {
        try {
            const response = await getReason("return");
            const { data } = response;
            if (data?.status === 200 && Array.isArray(data?.data)) {
                setReasonList(data.data);
            } else {
                setReasonList([]);
            }
        } catch (error) {
            console.error("Failed to fetch reasons:", error);
            setReasonList([]);
            toast.error("Unable to load cancellation reasons");
        }
    }, []);

    /**
     * Redirect if no items
     */
    useEffect(() => {
        // if (!items?.length) {
        //     navigate("/accounts/orders", { replace: true });
        //     return;
        // }

        fetchReasons();
    }, [items, navigate, fetchReasons]);

    /**
     * Submit return order request
     */
    const submitReturnItems = useCallback(async () => {
        const trimmedComments = comments.trim();

        if (!reason) {
            toast.error("Please select a return reason");
            return;
        }

        if (trimmedComments.length < 5) {
            toast.error("Comments must be at least 5 characters");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                item_ids: items.map((item) => item.id),
                reason_id: Number(reason),
                remarks: trimmedComments
            };

            const response = await API.put(
                `/orders/${orderNo}/return`,
                payload
            );

            const { data } = response;

            if (data?.success) {
                toast.success("Order returned successfully");

                navigate(`/accounts/orders/${orderNo}`, {
                    replace: true,
                    state: { returned: true }
                });

                return;
            }

            toast.error(data?.message || "Return failed");
        } catch (error) {
            console.error("Return order error:", error);
            toast.error(
                error?.response?.data?.message ||
                "Return failed"
            );
        } finally {
            setLoading(false);
        }
    }, [reason, comments, items, orderNo, navigate]);

    return {
        reason,
        setReason,
        reasonList,
        comments,
        setComments,
        loading,
        submitReturnItems
    };
};
